import React from "react";
import { useIntl } from "react-intl";
import { Spin, Row, Col } from "antd";

const Load = ({ noMessage, message, size, rowProps }) => {
  const intl = useIntl();
  return (
    <Row type="flex" {...rowProps} justify="center" className="margin-bottom-1">
      <Col>
        <Spin
          tip={
            noMessage
              ? undefined
              : message ||
                intl.formatMessage({
                  id: "messages.loading",
                  defaultMessage: "Načítání",
                })
          }
          size={size || "large"}
        />
      </Col>
    </Row>
  );
};

export default Load;
